"use client";
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useRef, MouseEventHandler } from "react";

import { MdArrowForward as ArrowForwardIcon } from "react-icons/md";

import { ImageCardProps } from "lib/types";

import AnimatedLink from "./animated-link";
import { Chip } from "./chip";
import { Typography } from "./typography";

export const ImageCard: React.FC<ImageCardProps> = ({
  children,
  chipColor = "yellow",
  chipLabel,
  className = "",
  component = "div",
  content,
  hasBackgroundGraphic = false,
  headingLevel = "h3",
  href,
  puffImage,
  showCategories = false,
  showChip = true,
  title,
}) => {
  const linkRef = useRef<HTMLAnchorElement>(null);

  const handleCardClick: MouseEventHandler<HTMLDivElement | HTMLLIElement> = (
    event,
    // eslint-disable-next-line consistent-return
  ): void => {
    if (
      linkRef?.current !== undefined &&
      // @ts-ignore
      !linkRef?.current?.contains(event.target)
    ) {
      // @ts-ignore
      return linkRef?.current?.click();
    }
    // Add your code here to handle the click event on the card element
  };

  const headingWithLineBreaks = title?.split("   ");

  const cardStyles: React.CSSProperties = {
    "--bg-image": `url(${puffImage?.url}?h=400&auto=format)`,
  } as React.CSSProperties;

  const caseCardGraphicClass = hasBackgroundGraphic ? "case-card-graphic" : "";

  const CardComponent = component;

  const listItemClasses = component === "li" ? "m-[initial]" : "";

  const paddingClasses = `px-4 py-6 sm:p-6 pb-8 md:p-8 md:pb-16`;

  const sharedClasses = `more-contrast-border group relative z-[10] flex min-h-[340px] cursor-pointer flex-col overflow-hidden rounded-lg bg-beige shadow-sm dark:bg-slate-800 case-card [&::after]:dark:brightness-75 ${className} `;

  return (
    <CardComponent
      className={`${sharedClasses} ${paddingClasses} ${listItemClasses} ${caseCardGraphicClass}`}
      onClick={handleCardClick}
      style={cardStyles}
    >
      <div>
        {!showCategories && showChip && chipLabel && (
          <div aria-hidden>
            <Chip color={chipColor} label={chipLabel} />
          </div>
        )}

        <AnimatedLink
          className="mt-4 flex flex-row justify-between gap-x-4 gap-y-2 focus-visible:!outline-none"
          href={href}
          ref={linkRef}
        >
          <div className="mb-3 ">
            <Typography
              className="relative z-10 inline w-fit max-w-prose rounded-sm bg-beige underline-offset-[0.15em] group-focus-within:underline group-hover:underline more-contrast:underline dark:bg-slate-800"
              component={headingLevel}
              variant="h3"
            >
              {/*  Hacky solution to insert soft hyphen when editors add triple space  */}
              {headingWithLineBreaks?.map((substring, index) =>
                headingWithLineBreaks.length > 1 && index > 0 ? (
                  <React.Fragment key={substring}>
                    &shy;{substring}
                  </React.Fragment>
                ) : (
                  <React.Fragment key={substring}>{substring}</React.Fragment>
                ),
              )}
              {"\u00A0"}
            </Typography>
          </div>
          <div className="relative z-10 h-fit rounded-sm bg-beige dark:bg-slate-800">
            <ArrowForwardIcon className="shrink-0 text-2xl opacity-70 group-focus-within:opacity-100 group-hover:opacity-100 more-contrast:opacity-100 lg:text-4xl" />
          </div>
        </AnimatedLink>
      </div>

      {content && (
        <div className="flex flex-col justify-between">
          <Typography className="mdplus:max-w-[60%]">{content}</Typography>
        </div>
      )}
      {children}
    </CardComponent>
  );
};

export default ImageCard;
